import {createSlice} from "@reduxjs/toolkit";

const cartSlice = createSlice({
    name: "cartReducer",
    initialState: {
        cartCount: 0,
        cartData: {}
    },
    reducers: {
        incrementCart(state, action) {
            state.cartCount++;
        },
        setCartValue(state, action) {
            state.cartCount = action.payload;
        },
        addToCart(state, action) {
            state.cartData = {...state.cartData, ...action.payload};
        },
        clearCart(state, action) {
            state.cartData = {};
        }
    }
});

export const cartAction = cartSlice.actions;

export default cartSlice;